module.exports = __webpack_public_path__ + "img/ico-administrateur.f511e904.svg";